import { RestoreableModel, ResourceFactory } from '../services/';

class Sample extends RestoreableModel {
  public campaign: {
    id: number;
    name: string;
  } = null;

  public station: {
    id: number;
    name: string;
  } = null;

  public depth:                number;
  public date:                 string;
  public time:                 string;
  public interval:             number;
  public tidal_situation:      string;
  public depth_type:           string;
}

const SampleFactory = ResourceFactory.create<Sample>(Sample, 'sample');

export { Sample, SampleFactory };
